import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../Card/Card";

function Pesquisado({ resultados, limpar }) {
  const navigate = useNavigate();

  // Função para ir à página de detalhes
  function irParaDetalhes(id) {
    navigate(`/projeto/${id}`);
  }

  return (
    <main style={{ padding: 20 }}>
      <div className="pesquisados-topo">
        <h1>Resultados da pesquisa</h1>
        <button onClick={limpar} className="btn-voltar-inicio">
          Voltar ao Início
        </button>
      </div>


      {resultados.length === 0 ? (
        <div className="estado-vazio">
          <p className="estado-vazio-texto">
            Nenhum resultado encontrado.
          </p>
        </div>
      ) : (
        <div
          className="pesquisados-grid"
        >
          {resultados.map((p) => (
            <Card
              key={p.id}
              projeto={p}
              onClick={() => irParaDetalhes(p.id)} // mesmo comportamento do Inicial
            />
          ))}
        </div>
      )}
    </main>
  );
}

export default Pesquisado;
